import { render, staticRenderFns } from "./CategoriaEdit.vue?vue&type=template&id=6e36b817&scoped=true&"
import script from "./CategoriaEdit.vue?vue&type=script&lang=js&"
export * from "./CategoriaEdit.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaEdit.vue?vue&type=style&index=0&id=6e36b817&prod&scoped=true&lang=css&"
import style1 from "./CategoriaEdit.vue?vue&type=style&index=1&id=6e36b817&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e36b817",
  null
  
)

export default component.exports